// The tokenizer bpe ranks are ~2MB, so load them as a separate chunk instead
// of bundling into the main entry. Used to come from an unversioned unpkg
// <script> global, which broke when the CDN switched to an ESM-only build.
let encodeFn = null
let loadPromise = null

export const loadGPTTokenizer = () => {
	if (!loadPromise) {
		loadPromise = import("gpt-tokenizer/encoding/o200k_base")
			.then((m) => {
				encodeFn = m.encode
				return encodeFn
			})
			.catch((e) => {
				console.error("loadGPTTokenizer failed", e)
				loadPromise = null
				return null
			})
	}

	return loadPromise
}

loadGPTTokenizer()

export const getGPTTokens = ({
	taskInput,
	taskInputType,
	encodeOverrideFunction = null,
}) => {
	try {
		if (!taskInput) {
			return 0
		}

		const encode = encodeOverrideFunction || encodeFn

		if (!encode) {
			return 0
		}

		if (taskInputType === "variants" && typeof taskInput !== "string") {
			return encode(JSON.stringify(taskInput), { allowedSpecial: "all" })
				.length
		} else {
			return encode(taskInput, { allowedSpecial: "all" }).length
		}
	} catch (e) {
		console.error("getGPTTokens catched error", e)
		console.log("getGPTTokens", {
			taskInput,
			taskInputType,
			encodeOverrideFunction,
		})
		return 0
	}
}
